import { Display } from '@/components/Display/Display';
import { useState, useEffect } from 'react';
import ToastUtils from '@/utils/ToastUtils';
import preImg from '@/assets/images/mobile/pre_icon.webp';
import MyIcon from '@/components/MyIcon';
import s from '../../Outside/pages/style/chat.module.scss';
const PreQuestion = ({ currentAgent = {}, submitMsg, disabled = false }) => {
    const [expand, setExpand] = useState(false);
    const [list, setList] = useState([]);

    const handleList = () => {
        let data = [];
        if (!expand) {
            data = currentAgent?.pre_question_json?.slice(0, 2);
        } else {
            data = currentAgent?.pre_question_json;
        }
        console.log(data, 'datataaa');
        setList(data);
    };
    const toggleExpand = () => {
        setExpand(!expand);
    };
    useEffect(() => {
        handleList();
    }, [expand, currentAgent]);
    return (
        <Display show={currentAgent?.pre_question_json && currentAgent?.pre_question_json?.length > 0}>
            <div className={s['preset-question-wrap']}>
                <div className={s['preset-question-title']}>
                    <img src={preImg} alt="" /> 试试这样问我
                </div>
                <Display show={list && list?.length}>
                    <div className={s['preset-question-list']}>
                        {list &&
                            list.map((ele, index) => {
                                return (
                                    <div
                                        onClick={() => {
                                            if (disabled) {
                                                ToastUtils.showToast('该技能暂不可用');
                                                return false;
                                            }

                                            submitMsg(ele, true);
                                        }}
                                        key={index}
                                        data-disabled={disabled}
                                        className={s['preset-question-item']}
                                    >
                                        {ele}
                                    </div>
                                );
                            })}
                    </div>
                </Display>
                <Display show={currentAgent?.pre_question_json?.length >= 3}>
                    <div className={s['expand-box']} onClick={toggleExpand}>
                        <MyIcon style={{ fontSize: '20px' }} type={expand ? 'icon-a-Frame427319955' : 'icon-a-Frame4273199541'}></MyIcon>
                    </div>
                </Display>
            </div>
        </Display>
    );
};
export default PreQuestion;
